<!--
 * @Author: houmy
 * @Date: 2023-10-10 14:26:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-19 18:12:31
 * @FilePath: \zx-home\src\views\solution.vue
 * @Description: 
 * 
-->


<template>
    <div class="page">
        <Contact></Contact>
        <img class="newsBanner" src="../assets/img/解决方案/解决方案banner.png" alt="">
        <div class="sulutionWrap home-box">
            <div class="w12">
                <div class="page-title">
                    <i></i>
                    <span>行业解决方案</span>
                </div>
                <ul class="sulutionMain">
                    <li class="flex-col" v-for="(item, index) in solutionArr" @click="toDetail(item.id)">
                        <img class="sulutionImg" :src="getImagePath(item.img)" />
                        <p class="flex-col">
                            <b>{{ item.title }}  <img src="@/assets/img/blueRight.png" /></b>
                            <span>{{ item.desc }}</span>
                        </p>
                    </li>

                </ul>
            </div>

        </div>

    </div>
</template>
    
<script>
import Contact from '../components/Contact.vue'
import solutionJson from '@/assets/data/solution.json'
export default {
    components: {
        Contact
    },
    data() {
        return {
            solutionArr:[]
        };
    },
    mounted() {
        this.solutionArr = solutionJson
        this.$nextTick(() => {
            window.scrollTo(0, 0)
        })
    
    },
    methods: {
        // 跳转详情
        toDetail(id) {
            this.$router.push({
                path: '/solutionDetail',
                query: {
                    id: id,
                }
            })
        },
         // 图片回显
         getImagePath(imageName) {
            return require(`@/assets${imageName}`);
        },

    }
};
</script>
    
<style scoped></style>
    


// WEBPACK FOOTER //
// src/views/Solution.vue